export const getEntityToolbarStyles = () => ({
    toolbar: {
        button: {
            minHeight: '32px',
            paddingY: '4px'
        }
    }
});